import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';

@Component({
  selector: 'app-otp-sms-consumption',
  templateUrl: './otp-sms-consumption.component.html',
  styleUrls: ['./otp-sms-consumption.component.scss']
})
export class OtpSmsConsumptionComponent implements OnInit {
  date ;
  selectedDate : any = ""
  count : any = 0;
   constructor(
     private apiService : ApiService,
     private apiConfig : ApiConfiguration,
     
   ) { 
     let currentDate = new Date()
     this.date = moment(currentDate).format("YYYY-MM")
     this.selectedDate = this.date
   }
 
   ngOnInit() {
   }
 
   
   getOtpData(){
    console.log(moment(this.selectedDate).format("MM"))
    let month = moment(this.selectedDate).format("MM");
    let year = moment(this.selectedDate).format("YYYY")
    this.apiService.get(this.apiConfig.pointsLedgerReport + `?report_id=24&month=${month}&year=${year}`).subscribe((res : any)=>{
      console.log(res)
      this.count = res.data.report_data[0].count;
    })
  }
}
